<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        md12
        sm12
        lg6
      >
        <material-chart-card
          :data="clientChart.data"
          :options="clientChart.options"
          color="gray"
          type="Bar"
        >
          <h4 class="title font-weight-light">New Clients by Month</h4>
          <p class="category d-inline-flex font-weight-light">
            <span v-if="this.clientIncrease >= 0">
              <v-icon
                color="green"
                small
              >
                mdi-arrow-up
              </v-icon>
              <span class="green--text">{{ this.clientIncrease }}%</span>&nbsp;
              increase in this month's clients
            </span>
            <span v-else>
              <v-icon
                color="red"
                small
              >
                mdi-arrow-down
              </v-icon>
              <span class="red--text">{{ this.clientIncrease }}%</span>&nbsp;
              decrease in this month's clients
            </span>
          </p>

        </material-chart-card>
      </v-flex>
      <v-flex
        md12
        sm12
        lg6
      >
        <material-chart-card
          :data="payoutChart.data"
          :options="payoutChart.options"
          color="gray"
          type="Bar"
        >
          <h4 class="title font-weight-light">Payout By Month</h4>
          <p class="category d-inline-flex font-weight-light">
            Contact blah blah blah if the numbers don't check out
          </p>
        </material-chart-card>
      </v-flex>
      <v-flex
        sm12
        xs6
        md6
        lg6
      >
        <material-stats-card
          :value="'$' + user.affiliate.last_paid_amount || 0"
          :sub-text="'Last payout time: ' + (new Date(user.affiliate.last_paid_time * 1000)).toDateString()"
          color="green"
          icon="mdi-currency-usd"
          title="Last Month Commission"
          sub-icon="mdi-calendar"
        />
      </v-flex>

      <v-flex
        sm12
        xs6
        md6
        lg6
      >
        <material-stats-card
          :value="'$' + payout"
          color="orange"
          icon="mdi-currency-usd"
          title="Upcoming Commission Payout"
          sub-icon="mdi-calendar"
          sub-text="Next payout is on the first of the month"
        />
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Dashboard',
  data () {
    return {
        payout: 0,
        payouts: [],
      clients: [],
      clientIncrease: 0,
        user: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  computed: {
    clientChart: function () {
        let date = new Date()
        var labels = this.clients.map(c => c.month)
        if (labels.length == 0) {
            labels = [ date.getMonth() + 1 + '-' + date.getFullYear() ]
        }
        var series = this.clients.map(c => parseInt(c.count))
        var high = Math.max(...series)
        if (series.length == 0) {
            series = [ 0 ]
            high = 1
        }

        return {
        data: {
          labels: labels,
          series: [
            series
          ]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: high + 0.1,
            onlyInteger: true,
          chartPadding: {
            top: 20,
            right: 0,
            bottom: 0,
            left: 20
          },
            axisY: {
              onlyInteger: true
            }
        }
      }
    },
      payoutChart: function () {
          let date = new Date()
          var labels = this.payouts.map(c => c.month)
          if (labels.length == 0) {
              labels = [ date.getMonth() + 1 + '-' + date.getFullYear() ]
          }
          var series = this.payouts.map(c => parseInt(c.amount))
          var high = Math.max(...series)
          if (series.length == 0) {
              series = [ 0 ]
              high = 1
          }

          return {
              data: {
                  labels: labels,
                  series: [
                      series
                  ]
              },
              options: {
                  lineSmooth: this.$chartist.Interpolation.cardinal({
                      tension: 0
                  }),
                  low: 0,
                  high: high + 0.1,
                  onlyInteger: true,
                  chartPadding: {
                      top: 20,
                      right: 0,
                      bottom: 0,
                      left: 20
                  }
              }
          }
      }
  },
  watch: {
    clients (val) {
      if (val.length === 0) {
        this.clientIncrease = 0
        return
      }

      var cur = parseFloat(val[val.length - 1].count)
      if (val.length > 1) {
        var pre = parseFloat(val[val.length - 2].count)
        this.clientIncrease = (cur - pre) / pre * 100
      } else {
        this.clientIncrease = 100
      }
    }
  },
  created () {
    this.getClients()
    this.getPayout()
    this.getPayouts()
  },
  methods: {
    complete (index) {
      this.list[index] = !this.list[index]
    },
    getClients () {
      axios.get('/api/reports/clients')
          .then(response => {
            this.clients = response.data
          })
          .catch(err => {
            console.log(err.response.data.errors)
          })
    },
      getPayout () {
          axios.get('/api/reports/payout')
              .then(response => {
                  this.payout = response.data
              })
              .catch(err => {
                  console.log(err.response.data.errors)
              })
      },

      getPayouts () {
          axios.get('/api/reports/payouts')
              .then(response => {
                  this.payouts = response.data
              })
              .catch(err => {
                  console.log(err.response.data.errors)
              })
      }
  }
}
</script>
